import { useEffect, useState } from 'react';
// material-ui
import { Typography, Box, Modal, IconButton, Grid, Tooltip } from '@mui/material';
import langString from 'utils/langString';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import FormValidators from 'utils/FormValidators';
import BatchForm from './Form';
import axiosServices from 'utils/axiosServices';
import { makeFormData, requestUrl } from 'utils/Helpers';
import { SnackBarType } from 'types/common';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 3
};

type EditBatchPropsType = {
    batchID: number;
    batchName: string;
    batchKey: string;
    batchCapacity: number;
    batchSchedules: string[];
    refreshList: () => void;
    setSnackbar: (value: SnackBarType) => void;
};
export default function EditBatch({
    refreshList,
    setSnackbar,
    batchID,
    batchName,
    batchKey,
    batchCapacity,
    batchSchedules
}: EditBatchPropsType) {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [enrollKey, setEnrollKey] = useState('');
    const [capacity, setCapacity] = useState(0);
    const [schedules, setSchedules] = useState<string[]>(['Sunday']);
    const [errors, setErrors] = useState<any>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const saveData = async () => {
        setIsSubmitting(true);
        const allErrors = FormValidators(['name', 'schedules', 'capacity'], [name, schedules, capacity]);
        if (allErrors.valid) {
            try {
                const response = await axiosServices.post(
                    requestUrl('ace_exam', 'edit_batch'),
                    makeFormData([
                        { key: 'batch_id', value: batchID },
                        { key: 'name', value: name },
                        { key: 'enrolment_key', value: enrollKey },
                        { key: 'max_students', value: capacity },
                        { key: 'schedules', value: schedules.filter((item) => item !== 'select') }
                    ])
                );
                if (response.data.success) {
                    refreshList();
                    setName('');
                    setEnrollKey('');
                    setCapacity(0);
                    setSchedules(['Sunday']);
                    setSnackbar({ open: true, message: response.data?.msg, alert: 'success' });
                } else {
                    setSnackbar({ open: true, message: response.data?.msg, alert: 'error' });
                }
            } catch (e) {
                console.log(e);
                setSnackbar({ open: true, message: langString('servererror') });
            }
            setOpen(false);
        } else {
            setErrors(allErrors);
        }
        setIsSubmitting(false);
    };

    useEffect(() => {
        setName(batchName);
        setCapacity(batchCapacity);
        setSchedules(batchSchedules);
        setEnrollKey(batchKey);
    }, [batchCapacity, batchKey, batchName, batchSchedules]);

    return (
        <>
            <IconButton onClick={() => setOpen(true)}>
                <Tooltip title={langString('edit')}>
                    <EditIcon />
                </Tooltip>
            </IconButton>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ borderBottom: '1px solid #000', marginBottom: 3 }}
                    >
                        <Grid item xs={6}>
                            <Typography variant="h4">
                                <EditIcon /> {langString('edit')} {langString('batch')}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <IconButton
                                color="secondary"
                                onClick={() => setOpen(false)}
                                aria-label="closeModal"
                                component="span"
                                sx={{ color: 'black', float: 'right' }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item xs={12}>
                            <BatchForm
                                name={name}
                                setName={(value: string) => setName(value)}
                                enrollKey={enrollKey}
                                setEnrollKey={(value: string) => setEnrollKey(value)}
                                capacity={capacity}
                                setCapacity={(value: number) => setCapacity(value)}
                                schedules={schedules}
                                setSchedules={(values: string[]) => setSchedules(values)}
                                errors={errors}
                                submitting={isSubmitting}
                                saveData={() => saveData()}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    );
}
